__turbopack_context__.v({
  "applyButton": "ApplyButton-module__6oL3Ka__applyButton",
  "applyButtonWrapper": "ApplyButton-module__6oL3Ka__applyButtonWrapper",
});
